import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@ff-os/shared-react/components/buttons/button/Button';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { Image } from '@ff-os/shared-react/components/image/Image';
import { WindowButton } from '@ff-os/shared-react/components/window/partials/WindowButton';
import { WindowFooter } from '@ff-os/shared-react/components/window/partials/WindowFooter';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { useCloseWindow } from '@ff-os/shared-react/context/window/useWindowContext';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { findReplaceTranslationKey } from '@ff-scene-plugins/gift-shared/findReplaceTranslationKey';
import { SvgInputOptionGrid } from './SvgInputOptionGrid';

export const SvgInputControlWindow = ({
    selectedAssetUrl, name, variableIds
}: Props) => {

    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const onClose = useCloseWindow(() => setIsOpen(false));

    const icon = selectedAssetUrl
        ? <Image src={selectedAssetUrl} width={24} height={24} />
        : <Icon type='option-engraving' />;

    const title = selectedAssetUrl
        ? t(findReplaceTranslationKey(name, 'variables_replace.emblem'))
        : t(name);

    return (
        <>
            <WindowButton chevron icon={icon} onClick={() => setIsOpen(true)}>
                {title}
            </WindowButton>

            <WindowContext isOpen={isOpen} close={() => setIsOpen(false)}>
                <WindowContext.Header>
                    <WindowHeader previous={onClose}>
                        {title}
                    </WindowHeader>
                </WindowContext.Header>
                <WindowContext.Body>
                    <SvgInputOptionGrid variableIds={variableIds} />
                </WindowContext.Body>
                <WindowContext.Footer>
                    <WindowFooter justify='end'>
                        <Button onClick={onClose}>
                            {t('commons.save')}
                        </Button>
                    </WindowFooter>
                </WindowContext.Footer>
            </WindowContext>
        </>
    );
};

type Props = {
    name: string;
    variableIds: string[];
    selectedAssetUrl: string;
};